export default "__VITE_ASSET__BrG0Dh6r__"